import { getSupportedLanguage } from '../../constants/academySupportedLanguages';
import { useLearningEvents, useSeriesEventsByLanguage } from './liveEventQueries';

// A declared SeriesError (e.g. SERIES_NOT_FOUND) carries a typed `reason` in the
// CHIRP failure's cause and just means "no series for this language" — a valid
// empty state we fall back from. A genuine failure (5xx, network) has no typed
// reason and should surface so the caller can show its error/retry UI instead
// of silently rendering nothing.
const hasDeclaredSeriesErrorReason = error => {
  var _networkError;
  if (typeof error !== 'object' || error === null) return false;
  const cause = (_networkError = error.networkError) === null || _networkError === void 0 ? void 0 : _networkError.cause;
  return typeof (cause === null || cause === void 0 ? void 0 : cause.reason) === 'string';
};
const isGenuineSeriesError = error => error != null && !hasDeclaredSeriesErrorReason(error);
export const useResolvedOnboardingSeriesEvents = ({
  userSelectedLanguage,
  skip = false,
  filterByPurchasedProductLines = false
} = {}) => {
  const uiLanguage = getSupportedLanguage();
  const resolvedLanguage = userSelectedLanguage !== null && userSelectedLanguage !== void 0 ? userSelectedLanguage : uiLanguage;
  const {
    orderedEventIds: primaryIds,
    seriesLoading: primaryLoading,
    seriesError: primaryError
  } = useSeriesEventsByLanguage(resolvedLanguage, {
    skip
  });
  const {
    orderedEventIds: enFallbackIds,
    seriesLoading: enFallbackLoading,
    seriesError: enFallbackError
  } = useSeriesEventsByLanguage('EN', {
    skip: skip || userSelectedLanguage !== undefined || resolvedLanguage === 'EN' || primaryLoading || primaryIds.length > 0
  });
  const orderedIds = primaryIds.length > 0 ? primaryIds : enFallbackIds;
  const seriesResolutionError = isGenuineSeriesError(primaryError) ? primaryError : isGenuineSeriesError(enFallbackError) ? enFallbackError : undefined;
  const {
    learningEvents: seriesEvents,
    learningEventsLoading: seriesEventsLoading,
    learningEventsError
  } = useLearningEvents({
    ids: orderedIds,
    pageLength: orderedIds.length || 1,
    filterByPurchasedProductLines
  }, {
    skip: skip || orderedIds.length === 0
  });
  return {
    orderedIds,
    sourceEvents: seriesEvents,
    loading: primaryLoading || enFallbackLoading || seriesEventsLoading,
    error: seriesResolutionError !== null && seriesResolutionError !== void 0 ? seriesResolutionError : learningEventsError
  };
};